import { Badge, Box, HStack, IconButton, Stack, Text, VStack } from '@chakra-ui/react';
import { MdDelete, MdEdit } from 'react-icons/md';

import Card from '@/components/ui/Card/Card';

import { SurveyField } from '../types';
import { getSurveyFieldTypeLabel } from '../utils';

type SurveyFieldListProps = {
  fields: SurveyField[];
  onEdit: (field: SurveyField) => void;
  onRemove: (fieldId: string) => void;
};

export const SurveyFieldList = ({ fields, onEdit, onRemove }: SurveyFieldListProps) => {
  if (fields.length === 0) {
    return (
      <Card>
        <Stack spacing={2} textAlign="center" py={6} color="gray.800">
          <Text fontWeight="semibold">Brak pól w ankiecie</Text>
          <Text fontSize="sm" color="gray.600">
            Dodaj przynajmniej jedno pytanie, aby opublikować ankietę.
          </Text>
        </Stack>
      </Card>
    );
  }

  return (
    <Stack spacing={3}>
      {fields.map((field) => (
        <Card key={field.id}>
          <Stack spacing={3} color="gray.800">
            <HStack justify="space-between" align="start">
              <VStack align="start" spacing={1}>
                <HStack spacing={2}>
                  <Text fontWeight="semibold">{field.label}</Text>
                  <Badge colorScheme="purple" variant="subtle">
                    {getSurveyFieldTypeLabel(field.type)}
                  </Badge>
                  {field.isRequired ? (
                    <Badge colorScheme="red" variant="outline">
                      Wymagane
                    </Badge>
                  ) : null}
                </HStack>
                {field.type === 'scale' && field.maxRate ? (
                  <Text fontSize="sm" color="gray.600">
                    Maksymalna ocena: {field.maxRate}
                  </Text>
                ) : null}
              </VStack>
              <HStack spacing={2}>
                <IconButton
                  aria-label="Edytuj pole"
                  icon={<MdEdit />}
                  size="sm"
                  variant="ghost"
                  onClick={() => onEdit(field)}
                />
                <IconButton
                  aria-label="Usuń pole"
                  icon={<MdDelete />}
                  size="sm"
                  variant="ghost"
                  colorScheme="red"
                  onClick={() => onRemove(field.id)}
                />
              </HStack>
            </HStack>
            {field.type === 'radio' || field.type === 'checkbox' ? (
              <Box>
                <Text fontSize="sm" fontWeight="semibold" mb={1}>
                  Opcje odpowiedzi:
                </Text>
                <Stack spacing={1}>
                  {field.options?.map((option) => (
                    <Text key={option.id} fontSize="sm" color="gray.700">
                      • {option.label}
                    </Text>
                  ))}
                </Stack>
              </Box>
            ) : null}
          </Stack>
        </Card>
      ))}
    </Stack>
  );
};
